export default {
  title: "",
  subtitle: "",
  path: "set_webhooks_success",
  paragraphs: [
    "If, for any reason, your server fails to receive a webhook, the notification will be marked as failed at that time. You can filter these failed notifications by using the failed=true query parameter with the endpoint above.",
    "After processing them, you can use their respective IDs to mark each notification as successful via the endpoint provided below."
  ],
  request: {
    method: "PUT",
    endpoint: "/notifications/:id",
    headersPayload: [
      {
        name: "id",
        type: "string",
        required: true,
        description: "UUID of the webhook/notification"
      }
    ],
    responses: {
      "data": {
        "url": "https://webhook.site/8efeee1c-8d3d-4d41-95ff-cc2ffb042f4b",
        "sent_at": null,
        "notification": {
          "type": "payment_failed",
          "transaction_id": "173e30f4-9956-4e86-8fc0-d27b125a8678"
        },
        "inserted_at": "2022-09-19T16:21:15.100177",
        "id": "58215ec6-8f2b-40d4-9e50-c790ace92957",
        "failed_at": null
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/documentation/data/WebHook/SetNotificationSuccess.js